import { useMemo } from "react";

import {
  chatThemeColors,
  type ChatThemeColors,
} from "../constants/themeColors";

import { useTheme } from "@/providers/ThemeProvider";

/**
 * Custom hook for accessing theme-aware colors specific to chat components
 * Provides easy access to properly themed colors for markdown, progress bars, and message bubbles
 * @returns Theme configuration object with colors, dark mode flag, and current theme key
 */
export const useChatTheme = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const themeKey = isDark ? "dark" : "light";

  const colors = useMemo(
    (): ChatThemeColors => chatThemeColors[themeKey],
    [themeKey]
  );

  return {
    colors,
    isDark,
    theme: themeKey,
  };
};
